

const InitialLog = () => { return ` 
.:+-                               .+=.
 :*%#:         WELCOME TO         .*#%-.
.=%%%#-.     Rot Shell V1.0     .:#%%%+.
.#%%%%#=.                      .-#%%%%#:
+%%%%%%%+.                    .+#%%%%%%+
#%%%%%%%%#=..              ..=#%%%%%%%%#
+%%%%%%%%%%#=.-=++****++=-.=#%%%%%%%%%%+
-%%%%%%%%%###%%%%%%%%%%%%%%###%%%%%%%%%-
.*%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%*.
.-#%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%#-.
.:*%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%*: 
.::*%+###%%%%%%%%%%%%%%%%%%%%%%%##+#*::.
.-+:+==#+%%%%%%%%%%%%%%%%%%%%%%+#==+:+-.
.++#::+=#=+%%%%%%%#--#%%%%%%%+=#==::#++.
.=+=%#::*#+:*%%%%%-  -%%%%%*:+#*::#%=+=.
.+#:#%##*###*=##%%.  .%%##=*###+##%#:#+.
.+#+.###+....:-#%%*::*%%#=:....*###:+#+.
.**+#.++##:..  .+#%%%%%+.  ..:##=+.*+#+.
.+*#*:..=#%###*=:#%%%%#:=*###%#=..:+#++.
.-#=*%#*=:-=#%%%#*%%%%*#%%%#=-:=*#%*=#-.
 .+%#.=##%##=*%%%%%%%%%%%%*=*#%##=:*%+. 
  .-##*+:=#%%*#%%%%%%%%%%##%%#=:+*##=.  
    .:**+-+%%%#%%%%%%%%%%#%%%+-+**-.    
       .-%#*%%%%#-    -#%%%%*##-.       
         .:*#%%%%%#+*#%%%%%#*:.         
           .-%###*+==+*####-.           
             .*%%%%%%%%%%*.             
              .:+##%%##+:.                            

|---------------------------|
| Type --help or -h for     |
| available commands        |
|---------------------------|
`;
};
export default InitialLog;